import { fmtMsg, isGuid, MessageHelper, NotificationType } from "@/commonui/utils";
import { CommonLocale } from "@/locales/localeid";
import { QuickViewContentModel, QuickViewExposureModel, QuickViewWindowService } from "@/services/quick-view-window";
import { QuickViewWindowType } from "@/util/enum";
import { Card, Icon } from "ant-design-vue";
import { isNull, isUndefined } from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";
import QuickViewDrawer from "../../views/lesson-plan/conversation-master-builder/quick-view-drawer/quick-view-drawer.vue";
import { QuickViewExtraModel } from "../quick-view/model";

@Component({
	components: { QuickViewDrawer, Card, Icon }
})
export default class QuickViewWindow extends Vue {
	@Prop({ default: QuickViewWindowType.Content }) quickViewType: any;
	@Prop({ default: null }) id: any;
	@Prop({ default: () => {} }) extra: QuickViewExtraModel | undefined;

	public isVisible: boolean = false;
	public loading: boolean = false;
	public contentData: QuickViewContentModel | null = null;
	public exposurData: QuickViewExposureModel | null = null;

	created() {}

	public get commonLocales() {
		return CommonLocale;
	}

	private getRequiredData() {
		this.setLoading(true);
		if (this.quickViewType === QuickViewWindowType.Content) {
			QuickViewWindowService.getContentText(this.id)
				.then((data) => {
					this.contentData = data;
					this.setLoading(false);
				})
				.catch((ex) => {
					this.setLoading(false);
				});
		} else if (this.quickViewType === QuickViewWindowType.Exposure) {
			QuickViewWindowService.getExposure(this.id)
				.then((data) => {
					this.exposurData = data;
					this.setLoading(false);
				})
				.catch((ex) => {
					this.setLoading(false);
				});
		}
	}

	private setLoading(value: boolean) {
		this.loading = value;
	}

	public handleChange() {
		this.isVisible = !this.isVisible;
		if (this.isVisible) {
			if (
				isUndefined(this.id) ||
				isNull(this.id) ||
				!isGuid(this.id) ||
				![QuickViewWindowType.Content, QuickViewWindowType.Exposure].includes(this.quickViewType)
			) {
				MessageHelper.Message(
					NotificationType.Failed,
					fmtMsg(this.commonLocales.CommonHttpArgumentIsNullOrInvalid)
				);
				return;
			}
			this.getRequiredData();
		} else {
			this.contentData = null;
			this.exposurData = null;
		}
	}
}
